export default __webpack_public_path__ + "img/sec-2-bg.png";